"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dictionaryArrayColumnMapper = exports.dictionaryColumnMapper = void 0;
function dictionaryColumnMapper({ value, }) {
    return value === null || value === void 0 ? void 0 : value.name;
}
exports.dictionaryColumnMapper = dictionaryColumnMapper;
dictionaryColumnMapper.displayName = 'dictionaryColumnMapper';
function dictionaryArrayColumnMapper({ value, }) {
    return (value || []).map((v) => v.name).join(', ');
}
exports.dictionaryArrayColumnMapper = dictionaryArrayColumnMapper;
dictionaryArrayColumnMapper.displayName = 'dictionaryArrayColumnMapper';
//# sourceMappingURL=dictionary-column-mapper.js.map